import { useLingui } from '@lingui/react/macro';

import { useClientCommunicationDrawerContext } from '@/components/comments/ClientCommunicationDrawer/ClientCommunicationDrawerContext';
import Button from '@/design_system/Button';
import IconComment from '@/icons/Comment.svg';
import useViewPort from '@/utils/useViewport';

export const ContactAfterSales = () => {
  const { isMobile } = useViewPort();
  const { t } = useLingui();

  const label = t({
    id: 'brand.request.contact-after-sales',
    message: `Contact us`,
  });

  const { setIsClientCommunicationDrawerOpen } = useClientCommunicationDrawerContext();

  if (isMobile) {
    return (
      <Button
        iconOnly
        variant="secondary-brand"
        size="large"
        ariaLabel={label}
        tooltip={label}
        onPress={() => setIsClientCommunicationDrawerOpen(true)}
      >
        <IconComment />
      </Button>
    );
  }

  return (
    <Button
      variant="secondary-brand"
      size="medium"
      onPress={() => setIsClientCommunicationDrawerOpen(true)}
      style={{ flex: 1 }}
    >
      <IconComment />
      {label}
    </Button>
  );
};
